import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getCategory } from '../selectors/app'
const mapStateToProps = createStructuredSelector({
  category: getCategory,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  category: string
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect